import * as React from 'react';

import { Svg, SvgPath, SvgProps, registerSVG } from '../../../components/svg';
export function Work(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0.5 0.5 12.5 10.5">
      <SvgPath
        d="M5.5 1H7.5C7.76522 1 8.01957 1.10536 8.20711 1.29289C8.39464 1.48043 8.5 1.73478 8.5 2V3H10.5C10.7652 3 11.0196 3.10536 11.2071 3.29289C11.3946 3.48043 11.5 3.73478 11.5 4V9.5C11.5 9.76522 11.3946 10.0196 11.2071 10.2071C11.0196 10.3946 10.7652 10.5 10.5 10.5H2.5C1.945 10.5 1.5 10.05 1.5 9.5V4C1.5 3.445 1.945 3 2.5 3H4.5V2C4.5 1.445 4.945 1 5.5 1ZM7.5 3V2H5.5V3H7.5Z"
        fill={props.fill || '#502314'}
      />
    </Svg>
  );
}

registerSVG('Work', Work);
